var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c("div", { staticClass: "w-full md:w-1/2 my-8 md:pr-10" }, [
      _c(
        "div",
        [
          _c(
            "h2",
            { staticClass: "leading-tight lg:leading-normal mb-6 text-4xl" },
            [_vm._v("Join the Community")]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "router-link",
            { staticClass: "button", attrs: { to: { name: "register" } } },
            [_vm._v("\n        CREATE MY ACCOUNT\n      ")]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w-full md:w-1/2 my-8 md:pl-10" }, [
      _c("div", [
        _c("h2", { staticClass: "mb-6 text-4xl" }, [_vm._v("Login")]),
        _vm._v(" "),
        _c("form", { attrs: { method: "POST" } }, [
          _c("div", { staticClass: "mb-4" }, [
            _c("label", { ref: "email", attrs: { for: "email" } }, [
              _vm._v("\n            Email\n          "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "'required|email'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email,
                  expression: "form.email",
                },
              ],
              attrs: { id: "email", type: "email", name: "email" },
              domProps: { value: _vm.form.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "email", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("email"),
                    expression: "errors.has('email')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.errors.first("email")) +
                    "\n          "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-4" }, [
            _c("label", { ref: "password", attrs: { for: "password" } }, [
              _vm._v("\n            Password\n          "),
            ]),
            _vm._v(" "),
            (_vm.input.showPassword ? "text" : "password") === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:8",
                      expression: "'required|min:8'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password",
                    },
                  ],
                  attrs: { id: "password", name: "password", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.form.password)
                      ? _vm._i(_vm.form.password, null) > -1
                      : _vm.form.password,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.form.password,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.form, "password", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "password",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "password", $$c)
                      }
                    },
                  },
                })
              : (_vm.input.showPassword ? "text" : "password") === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:8",
                      expression: "'required|min:8'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password",
                    },
                  ],
                  attrs: { id: "password", name: "password", type: "radio" },
                  domProps: { checked: _vm._q(_vm.form.password, null) },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form, "password", null)
                    },
                  },
                })
              : _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:8",
                      expression: "'required|min:8'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password",
                    },
                  ],
                  attrs: {
                    id: "password",
                    name: "password",
                    type: _vm.input.showPassword ? "text" : "password",
                  },
                  domProps: { value: _vm.form.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "password", $event.target.value)
                    },
                  },
                }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "password-show-hide",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.input.showPassword = !_vm.input.showPassword
                  },
                },
              },
              [_c("eye", { attrs: { off: _vm.input.showPassword } })],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("password"),
                    expression: "errors.has('password')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.errors.first("password")) +
                    "\n          "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col" }, [
            _c("div", { staticClass: "mr-6 mt-6 mb-6" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n              Login\n            ")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {},
              [
                _c(
                  "router-link",
                  { staticClass: "text-black", attrs: { to: "/auth/forgot" } },
                  [
                    _vm._v(
                      "\n              Forgot your password?\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "font-sans-book text-n-gray-dark text-lg leading-normal pr-10",
      },
      [
        _c("p", { staticClass: "mb-8" }, [
          _vm._v(
            "\n          First visit to the Portal? Register here. If you already have an account, enter your login credentials on the right.\n        "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }